module.exports = __webpack_public_path__ + "04_long_brown.492ac6ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_long_brown.png
// module id = WNnl
// module chunks = 0